// extracted by mini-css-extract-plugin
module.exports = {"Infobox":"_3H6NzE"};